import React from 'react';
import style from './userDataProfile.module.css';
import useIsOwner from '../../../../../../customHooks/useIsOwner';
import ContactsProfileInfo from './Contacts/ContactsProfileInfo';
import ButtonStyleWrapper from '../../../../../commonComponents/ButtonStyleWrapper/ButtonStyleWrapper';

const UserDataProfile = (props) => {
    const isOwner = useIsOwner();
    return (
        <div className={style.container}>
            <span className={style.looking}>
                <p>Looking for a job: </p>
                <i>{props.lookingForAJob ? 'Yes' : 'No'}</i>
                <p>Comment: </p>
                <i>{props.lookingForAJobDescription ? props.lookingForAJobDescription : 'None'}</i>
            </span>
            <span className={style.aboutMe}>
                <p>About me: </p>
                <i>{props.aboutMe ? props.aboutMe : 'None'}</i>
            </span>
            {isOwner && <ButtonStyleWrapper>
                <button onClick={props.editHandler}>Edit Profile</button>
            </ButtonStyleWrapper>}
            <ContactsProfileInfo contacts={props.contacts} />
        </div>
    )
};

export default UserDataProfile;